// extracted by mini-css-extract-plugin
module.exports = {"widget":"I-fnH","disabled":"_28G0V"};